import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import {
  COPY_ONLY_PLAN,
  COPY_PLAN_WITH_DRIVERS,
} from "../../../consts/strings";
import { DayChips } from "../../DayChips/DayChips";
import { Text } from "../../Base";
import { View } from "../../View";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    gap: "10px",
  },
  daysContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "10px",
    gap: "2px",
  },
  text: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  radioButton: {
    height: "30px",
    padding: "0px",
    "& .MuiFormControlLabel-label": {
      fontSize: "12px",
    },
  },
});

export const CopyContent = ({
  selectedDays,
  onDaySelect,
  copySettings,
  onCopySettingsChange,
  disabledDays,
  incompatibleDays,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Text className={styles.text}>Daily Plan:</Text>
      <View className={styles.daysContainer}>
        <DayChips
          onDaySelected={(item) => onDaySelect(item)}
          selected={selectedDays}
          disabledDays={disabledDays}
          incompatibleDays={incompatibleDays}
        />
      </View>
      <Text className={styles.text}>Copy Settings:</Text>
      <View>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            aria-label="copy-settings"
            name="copySettings"
            value={copySettings}
            onChange={({ target }) => onCopySettingsChange(target.value)}
          >
            <FormControlLabel
              className={styles.radioButton}
              value={COPY_ONLY_PLAN}
              control={<Radio color={"primary"} size={"small"} />}
              label="Copy Plan Only/Keep Current Drivers"
            />
            <FormControlLabel
              className={styles.radioButton}
              value={COPY_PLAN_WITH_DRIVERS}
              control={<Radio color={"primary"} size={"small"} />}
              label="Copy Plan With Drivers"
            />
          </RadioGroup>
        </FormControl>
      </View>
    </View>
  );
};
